<template>
  <div>
    <el-dialog title="批量设置"  :visible.sync="batchsettingsVisible"   @close="handleDialogCloseAnoth">
      <el-form label-position="left" :model="awaitForm" :rules="rules" :disabled="isReadOnly" ref="ruleForm" :label-width="formLabelWidth">
        <!-- <el-form-item label="节点名称" prop="name">
          <el-input v-model="awaitForm.name" autocomplete="off" show-word-limit :maxlength="20"> </el-input>
        </el-form-item> -->
      <!-- Note等待节点设置 -->
      <el-form-item label="已选择节点数:"  style="margin-left:8px">
        <span style="margin-left:-8px">{{batNum}}个</span>
      </el-form-item>
      <el-form-item label="节点类型:"   style="margin-left:36px">
        <span style="margin-left:-36px">等待</span>
      </el-form-item>
        <el-form-item label="批量设置:" style="margin-left:36px">
          <div class="lineBox">
            <span style="margin-left:-35px;margin-right:15px">等待时间</span>
            <el-radio v-model="awaitForm.waitType" label="0">等待至指定时间</el-radio>
            <el-date-picker
              v-model="awaitForm.waitDateTime"
              :editable="false"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
              :picker-options="pickerOptions"
              :default-time="defaultTime"
              @change="datetimeChage"
              @focus="getDefaultTime"
              style="margin: 0 10px"
            >
            </el-date-picker>
          </div>
          <div class="lineBox" >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<el-radio v-model="awaitForm.waitType" label="1" style="margin-left: 3px;">等待</el-radio>
            <el-input v-model="awaitForm.waitDays" style="width:100px;margin: 0 10px"></el-input>
            <span>天</span>
            <el-time-picker
              class="time-picker"
              v-model="awaitForm.waitHourAndMinutes"
              :editable="false"
              format="HH:mm"
              value-format="HH:mm"
              :picker-options="{
                selectableRange: '00:00:00 - 23:59:59'
              }"
              @change="eventTimeChage"
              style="margin: 0 10px">
            </el-time-picker>
          </div>
          <div class="lineBox">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<el-radio v-model="awaitForm.waitType" label="2" style="margin-left: 3px;">等待时间</el-radio>
            <el-input v-model="awaitForm.waitHours" style="width:80px;margin: 0 10px"></el-input>
            <span>小时</span>
            <el-input v-model="awaitForm.waitMinutes" style="width:80px;margin: 0 10px"></el-input>
            <span>分钟</span>
          </div>
        </el-form-item>
        <!-- <div>
          <div style="width:900px;line-height:22px;color:red;margin-top:-16px;margin-bottom:4px">
            <div>注意：</div>
            <div>
              （1）双11大促期间短信发送时间：10月9日、10月10日、10月14日-10月16日、10月30日-11月1日、11月9日-11月11日 9:00-24:00 ；10月11日-10月13日、10月17日-10月29日、11月2日—11月8日 9:00-21:00 ；11月12日起恢复正常，即 09:00-20:00（*包含普通短信、富信、卡片短信）
            </div>
            <div>
              （2）10月9日-11月11日双11大促期频控规则：同一店铺2天内给同一手机号发送商家营销短信的条数不超过1条;每个手机号每1天只能收到5条商家营销短信,每2天只能收到10条商家营销短信（*商家营销短信包括普通短信、富信、卡片短信）
            </div>
          </div>
        </div> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchsettingsVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="isReadOnly" @click="awaitSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import mnode from "@/api/intelligentMarket/a_node";
import { getSendTime } from "@/api/smsSend";
export default {
  name: "awaitDialog",
  props: {
    batNum: {
      type:null
    },
    nodeBatch:{
      type: null,
    },
    // visible: {
    //   type: Boolean,
    //   default: false,
    // },
    // nodeId: Number,
    // marketingId: Number,
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    "awaitForm.waitDateTime": {
      handler(newValue, oldValue) {
        if ((newValue && oldValue && newValue.substring(0, 10) != oldValue.substring(0, 10)) || (newValue && !oldValue)) {
          if (this.isEdit) {
            this.isEdit = false;
            return;
          }
          var val = newValue.substring(0, 10);
          var nowTime10 = this.$getNowDate();
          var time1 = nowTime10.substring(0, 10);
          var time2 = nowTime10.substring(11, 19);
          var startTime = this.limitTime.startTime;
          var endTime = this.limitTime.endTime;
          // var time2 = "20:58:59";
          var arr = time2.split(":");
          var endArr = endTime.split(":");

          // 最晚可以选到时间
          if (arr[0] > endArr[0]) {
            time2 = endTime;
          } else if (arr[0] == endArr[0] && arr[1] > endArr[1]) {
            time2 = endTime;
          } else if (arr[0] == endArr[0] && arr[1] == endArr[1] && arr[2] >= endArr[2]) {
            time2 = endTime;
          }

          if (val == time1) {
            this.awaitForm.waitDateTime = val + " " + time2;
            this.pickerOptions.selectableRange = time2 + " - " + endTime;
          } else {
            // this.awaitForm.waitDateTime = val + ' ' + startTime;
            this.pickerOptions.selectableRange = startTime + " - " + endTime;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.limitSendTime();
    console.log('batNum',this.batNum,this.nodeBatch);
    // mnode.getNode({ nodeId: this.nodeId }).then((res) => {
    //   if (res.code === 1 && res.data.name) {
    //     let formData;
    //     if (res.code == 1) {
    //       formData = res.data;
    //       // formData.name = res.data.name;
    //       // this.awaitForm = formData
    //       this.awaitForm.name = res.data.name;
    //       this.isEdit = true;
    //       this.awaitForm.waitDateTime = res.data.waitTime;
    //       this.awaitForm.nodeId = res.data.nodeId;
    //     } else {
    //       this.awaitForm.name = res.data.name;
    //     }
    //   }
    // });
  },
  data() {
    return {
      // visible: true,
      batchsettingsVisible:true,
      defaultTime: "",
      formLabelWidth: "110px",
      rules: {
        name: [
          { required: true, message: "请输入节点名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      awaitForm: {
        name: "",
        waitType: "0",
        waitDateTime: "",
        waitDays: "",
        waitHourAndMinutes: "00:00",
        waitHours: "",
        waitMinutes: "",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date().getTime() - 24 * 60 * 60 * 1000 || time.getTime() > Date.now() + 8.64e7 * 90;
        },
        selectableRange: "9:00:00 - 19:55:59",
      },
      limitTime: {},
      isEdit: false, // 是否编辑回显
    };
  },
  computed: {
    viewVisible: {
      get: function() {
        return this.visible;
      },
      set: function(newValue) {
        if (newValue) {
          this.$emit("update:visible", true);
        } else {
          this.$emit("update:visible", false);
        }
      },
    },
  },
  methods: {
    handleDialogCloseAnoth () {
      this.$emit("close", true);
      this.batchsettingsVisible = true;
    },
    limitSendTime() {
      getSendTime().then((res) => {
        this.limitTime = res.data;
        var selectableRange = res.data.startTime + " - " + res.data.endTime;
        this.pickerOptions.selectableRange = selectableRange;
      });
    },
    awaitSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let formData = this.getDataify();
          let wait = {};
          var batchEasy = []
          this.nodeBatch.forEach((e,index)=>{
              batchEasy.push(e.nodeId)
          })
          // wait.name = formData.name;
          wait.nodeIds = batchEasy;
          const waitNode = {
            waitType:formData.waitNode.waitType
          }
          if(formData.waitNode.waitType == 0){
            waitNode.waitDateTime = formData.waitNode.waitDateTime
          }else if(formData.waitNode.waitType == 1){
            waitNode.waitDays = formData.waitNode.waitDays
            waitNode.waitHourAndMinutes = formData.waitNode.waitHourAndMinutes
          }else if(formData.waitNode.waitType == 2){
            waitNode.waitHours = formData.waitNode.waitHours
            waitNode.waitMinutes = formData.waitNode.waitMinutes
          }
          wait.waitNode = waitNode
          if (wait) {
            mnode.batchUpdate(wait).then((res) => {
              if (res.code === 1) {
                this.$message.success(res.message);
                this.batchsettingsVisible = false
                this.$emit("change-name", wait);
              }else{
                this.$message.error(res.message)
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    handleClose() {},
    getDataify() {
      let formData = {};
      let now = new Date();
      let time = now.getTime();
      let setTime;
      if (this.awaitForm.waitType === "0") {
        if (!this.awaitForm.waitDateTime) {
          this.$message.error("请选择等待指定时间！");
          return false;
        } else {
          setTime = new Date(this.awaitForm.waitDateTime).getTime() - time;
        }
      }
      if (this.awaitForm.waitType === "1") {
        if (!this.awaitForm.waitDays) {
          this.$message.error("请填写等待天数！");
          return false;
        } else if (!new RegExp("^\\d{0,2}$|^100$", "g").test(this.awaitForm.waitDays)) {
          this.$message.error("等待天数为2位数以内整数！");
          return false;
        } else if (!this.awaitForm.waitHourAndMinutes) {
          this.$message.error("请选择等待时间！");
          return false;
        } else {
          setTime = parseInt(this.awaitForm.waitDays) * 86400000;
          if (this.awaitForm.waitHourAndMinutes) {
            let relativeStartTimes = this.awaitForm.waitHourAndMinutes.split(":");
            setTime = setTime + parseInt(relativeStartTimes[0]) * 3600000 + parseInt(relativeStartTimes[1]) * 60000;
          }
        }
      }
      if (this.awaitForm.waitType === "2") {
        if (!this.awaitForm.waitHours) {
          this.$message.error("请填写等待小时数！");
          return false;
        } else if (!new RegExp("^\\d{0,3}$", "g").test(this.awaitForm.waitHours)) {
          this.$message.error("等待小时数为3位数以内整数！");
          return false;
        } else if (!this.awaitForm.waitMinutes) {
          this.$message.error("请填写等待分钟数！");
          return false;
        } else if (!new RegExp("^\\d{0,3}$", "g").test(this.awaitForm.waitMinutes)) {
          this.$message.error("等待分钟数为3位数以内整数！");
          return false;
        } else {
          setTime = parseInt(this.awaitForm.waitHours) * 3600000 + parseInt(this.awaitForm.waitMinutes) * 60000;
        }
      }
      if (setTime < 1800000) {
        this.$message.error("等待时间要大于当前时间30分钟！");
        return false;
      }
      formData.smartMarketingNodeId = this.$props.nodeId;
      formData.name = this.awaitForm.name;
      formData.waitNode = JSON.parse(
        JSON.stringify(this.awaitForm, (key, value) => {
          if (key === "name") {
            return undefined;
          }
          return value;
        })
      );
      return formData;
    },
    datetimeChage(dateTime) {
      if (this.awaitForm.waitType === "0") {
        let now = new Date().getTime();
        let setTime = new Date(dateTime).getTime();
        setTime - now < 1800000 && this.$message.error("等待时间要大于当前时间30分钟！");
      }
    },

    getDefaultTime() {
      let now = new Date().getTime();
      now = now + 31 * 60000;
      now = new Date(now);
      this.defaultTime = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
    },
    eventTimeChage(time) {
      if (this.awaitForm.waitType === "1" && (this.awaitForm.waitDays === "0" || !this.awaitForm.waitDays)) {
        let relativeStartTimes = time.split(":");
        if (!(relativeStartTimes[0] > 0)) {
          let setTime = parseInt(relativeStartTimes[1]) * 60000;
          setTime < 1800000 && this.$message.error("等待时间要大于当前时间30分钟！");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.time-picker{
  /deep/ .el-input__inner{
    padding-left: 30px!important;
  }
}
</style>
